import React from "react";
import { VariantProps } from ".";
import LoginOrEnterEmail from "./LoginOrEnterEmail";
const K = ({
  mapPrice,
  selectedProduct,
  productListingView
}: VariantProps) => {
  return <div className="map map-override mapK" data-sentry-component="K" data-sentry-source-file="K.tsx">
      <LoginOrEnterEmail {...{
      unitOfMeasure: selectedProduct.unitOfMeasure,
      mapPrice,
      type: selectedProduct.price.minimumAdvertisedPriceProperties.type,
      itemNumber: selectedProduct.itemNumber,
      price: selectedProduct.price,
      showLoginLink: selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers,
      priceTextSize: "small",
      productListingView
    }} data-sentry-element="LoginOrEnterEmail" data-sentry-source-file="K.tsx" />
    </div>;
};
export default K;